
import React, { PropsWithChildren, Fragment } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './Article.css';
import { getSecChildren } from '../PageSection/PageSection';
import * as ArticleModel from '../../types/shared/Article';
import withAsyncImport from '../../withAsyncImport';
import { Row, Col, Title, Container } from '../../importCL';
import Button from '../../component-library/atoms/Button/Button';
const CobGrid = withAsyncImport(() => import('../CobGrid/CobGrid'));

interface IArticleProps extends ArticleModel.Article, MappedComponentProperties {
    horizontalRuleRemoved?: boolean;
    articleInfoRemoved?: boolean;
    tags?: any[];
    topics?:any[];
    author?: { key: string, value: string };
    authorOrArticleFeed?: boolean;
    tagFeed?: boolean;
    hideImage?: boolean;
    cqItems?: any;
    cqItemsOrder?: string[];
}

export const ArticleEditConfig = {
    emptyLabel: 'Article',
    isEmpty: (props: PropsWithChildren<IArticleProps>) => {
        return !props || !props.title;
    },
};

const Article = (props: PropsWithChildren<IArticleProps>): JSX.Element => {

    return (<Container id='article' className='Article'>
        {!props.authorOrArticleFeed &&
            <Row>
                <Col xs={6} md={12} className='!pt-6'>
                    {(!props.articleInfoRemoved && props.tags && props.tags.length >= 1) &&
                        props.tags.map((el, i) => (
                            <Fragment key={i}>
                                <a
                                    className='no-underline font-bold hover:text-[#0078a0]'
                                    href={el.value}
                                >
                                    {el.key}
                                </a>
                                {props.tags &&
                                    <span data-testid='Article__tags' className='Article__tagsComma'>
                                        {i < props.tags.length - 1 && ', '}
                                    </span>}
                            </Fragment>
                        ))}
                    {props.title &&
                        <Title
                            className={`text-grey-tundora text-[2.5rem] ${props.tagFeed ? 'mb-12':''} ${!props.articleInfoRemoved ? 'my-0 !mt-2 !mb-5' :''}`}
                            tag='h1'>
                            {transformHTMLParserLinks(props.title)}
                        </Title>}
                    {props.subtitle &&
                        <p className='text-base font-bold mb-5 h6'>{transformHTMLParserLinks(props.subtitle)}</p>}
                </Col>
                {!props.articleInfoRemoved &&
                    <>
                        <Col xs={6} md={12} data-testid='Article__info'  className='flex'>
                            {props.author?.key &&
                                <p className='!mb-[0.625rem] pr-4'>
                                    Author:{' '}
                                    <a
                                        href={props.author.value}
                                        data-testid='Author__links'
                                        className='no-underline font-bold hover:text-[#0078a0]'
                                    >
                                        {props.author.key}
                                    </a>
                                </p>}
                            <p className='!mb-0'> {props.date}</p>
                        </Col>
                        <Col xs={6} md={12}>
                            {props.topics && props.topics.length >= 1 &&
                                <>
                                    <p className='inline mr-2'>Topics:</p>
                                    {props.topics?.map((e, i) => {
                                        return (
                                            <Button
                                                key={i}
                                                variant='chip'
                                                size='medium'
                                                href={e.value}
                                                className='mr-6'
                                                >
                                                {e.key}
                                            </Button>
                                        );

                                    })}
                                </>
                            }
                        </Col>
                    </>
                }
                <Col>
                    {!props.horizontalRuleRemoved &&
                        <hr className='border border-solid border-gray-200 mb-6 mt-10 border-t border-x-0 border-b-0 [@media(min-width:769px)]:my-12'/>}
                    {props.firstParagraph &&
                        <span className='!mb-[0.625rem]'>{transformHTMLParserLinks(props.firstParagraph)}</span>}

                    {(props.imagePath && !props.hideImage) &&
                        <img loading='lazy' alt={props.imageAlt} src={props.imagePath} className='my-6'/>}
                </Col>
            </Row>
        }
        <Row className='!p-0'>
            <Col>
                {props.cqItems && props.cqItems.articleParsys &&
                <CobGrid isInEditor={props.isInEditor} cqPath={`${props.cqPath}/articleParsys`} cqItems={getSecChildren(props, 'articleParsys')} cqItemsOrder={props.cqItems.articleParsys[':itemsOrder']} />
                }
            </Col>
        </Row>
    </Container>);
};

export default Article;
